import { render, staticRenderFns } from "./ModalStudentHistory.vue?vue&type=template&id=4e79149f&scoped=true&lang=pug&"
import script from "./ModalStudentHistory.vue?vue&type=script&lang=ts&"
export * from "./ModalStudentHistory.vue?vue&type=script&lang=ts&"
import style0 from "./ModalStudentHistory.vue?vue&type=style&index=0&id=4e79149f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e79149f",
  null
  
)

export default component.exports